import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SALDOSINICIALES_EDITARPORGRUPO, SALDOSINICIALES_NUEVO, SALDOSINICIALES_LISTA } from 'constants/codigosTransacciones'

import NuevoPage from './nuevo'
import ListaPage from './lista'
import EditarPorGrupoPage from './editarPorGrupo'

export default function SaldosInicialesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SALDOSINICIALES_EDITARPORGRUPO}`} component={EditarPorGrupoPage} />
        <Route path={`/${SALDOSINICIALES_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${SALDOSINICIALES_NUEVO}`} component={NuevoPage} />
        <Route path={`/${SALDOSINICIALES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
